<template>
	<div>
		<el-container class="navpage">
			<el-main style="padding: 0 10px;">
				<el-button type="warning" size="mini" icon="el-icon-edit" @click="addKeyword('')">添加SEO优化词</el-button>
				<el-button-group>
					<el-button type="primary" size="mini" icon="el-icon-select" @click="selectAll">全选</el-button>
					<el-button type="warning" size="mini" icon="el-icon-select" @click="selectDiff">反选</el-button>
				</el-button-group>
				<el-dropdown trigger="click">
					<el-button type="primary" icon="el-icon-setting" size="mini">
						筛选
						<i class="el-icon-arrow-down el-icon--right"></i>
					</el-button>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item v-for="(items, index) in filtrateList" :key="index">
							<el-dropdown trigger="hover" placement="right-start" @command="seleCommand">
								<el-button type="text" icon="el-icon-caret-right" size="mini">{{ items.label }}</el-button>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item
										icon="el-icon-caret-right"
										v-for="(item, key) in items.seconds"
										:key="key"
										:command="{ indexa: index, indexb: key, param: items.paramValue, paramval: item.val }"
										:class="item.checked ? 'color-blue' : ''"
									>
										{{ item.label }}
									</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteKeyword">删除</el-button>
				<el-button type="warning" size="mini" icon="el-icon-refresh">刷新</el-button>
				<el-dropdown trigger="click">
					<el-button type="success" icon="el-icon-setting" size="mini">
						设置
						<i class="el-icon-arrow-down el-icon--right"></i>
					</el-button>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item v-for="(items, index) in setList" :key="index">
							<el-dropdown trigger="hover" placement="right-start" @command="setCommand">
								<el-button type="text" icon="el-icon-caret-right" size="mini">{{ items.label }}</el-button>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item
										icon="el-icon-caret-right"
										v-for="(item, index) in items.seconds"
										:key="index"
										:command="{ setParam: items.paramValue, setParamVal: item.val }"
									>
										{{ item.label }}
									</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<el-table
					ref="multipleTable"
					:data="keywordList"
					style="width: 100%;margin-bottom: 20px;"
					row-key="kid"
					:stripe="true"
					:default-sort="{ prop: 'ctime', order: 'ascending' }"
					@sort-change="sortChange"
					@selection-change="selectChange"
					tooltip-effect="dark"
				>
					<el-table-column type="selection" width="55"></el-table-column>
					<el-table-column prop="kid" label="序号" width="80" sortable></el-table-column>
					<el-table-column prop="pid" label="排列号" sortable></el-table-column>
					<el-table-column prop="mid" label="所属模型">
						<template slot-scope="scope">
							{{ mlist[scope.row.mid].modelname }}
						</template>
					</el-table-column>
					<el-table-column prop="keywordname" label="SEO优化词名称" show-overflow-tooltip></el-table-column>
					<el-table-column prop="hit" label="查阅次数" show-overflow-tooltip></el-table-column>
					<el-table-column prop="mid" label="链接类型">
						<template slot-scope="scope">
							{{ ['内链', '外链'][scope.row.islink] }}
						</template>
					</el-table-column>
					<el-table-column prop="istop" label="热门关键词">
						<template slot-scope="scope">
							<i :class="scope.row.istop ? 'el-icon-check color-green' : 'el-icon-close color-red'"></i>
						</template>
					</el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope">
							<el-button type="warning" size="mini" @click="addKeyword(scope.row)">修改</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="block">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:current-page="thispage"
						:page-sizes="pageSizes"
						:page-size="pagesize"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
					></el-pagination>
				</div>
			</el-main>
		</el-container>
	</div>
</template>
<script>
export default {
	name: '',
	data() {
		return {
			thispage: 1,
			total: 0,
			pagesize: 10, //每页显示条数
			pageSizes: [10, 15, 20, 30], //每页显示个数选择器
			sort_param: '', //排序字段
			sort_type: '', //排序方式ascending = asc;descending = desc,'' = asc;
			keywordList: [],
			mlist: [],
			selectedKeywordIds: [],
			setList: [
				{
					label: '热门关键词',
					paramValue: 'istop',
					seconds: [
						{
							val: 1,
							label: '开启'
						},
						{
							val: 0,
							label: '关闭'
						}
					]
				}
			],
			filtrateList:[
				{
					label: '所属模型',
					paramValue: 'mid',
					seconds: [
						{
							val: '',
							label: '全部',
							checked: true
						}
					]
				},
				{
					label: '热门关键词',
					paramValue: 'istop',
					seconds: [
						{
							val: '',
							label: '全部',
							checked: true
						},
						{
							val: 1,
							label: '启用'
						},
						{
							val: 0,
							label: '禁用'
						}
					]
				},
				{
					label: '链接类型',
					paramValue: 'islink',
					seconds: [
						{
							val: '',
							label: '全部',
							checked: true
						},
						{
							val: 1,
							label: '外链'
						},
						{
							val: 0,
							label: '内链'
						}
					]
				}
			],
			setParam: '',
			setParamVal: '',
			selectParams: [],
		};
	},
	mounted() {
		this.getKeywordList(1);
	},
	methods: {
		handleOpen(key, keyPath) {
			console.log(key, keyPath);
		},
		handleClose(key, keyPath) {
			console.log(key, keyPath);
		},
		sortChange({ column, prop, order }) {
			console.log(column, prop, order);
			this.sort_param = prop;
			this.sort_type = order == 'descending' ? 'desc' : 'asc';
			this.getKeywordList();
		},
		handleSizeChange(val) {
			// console.log(`每页 ${val} 条`);
			this.pagesize = val;
			this.getKeywordList();
		},
		handleCurrentChange(val) {
			// console.log(`当前页: ${val}`);
			this.thispage = val;
			this.getKeywordList();
		},
		getKeywordList(firstLoad = 0) {
			this.selectedKeywordIds = [];//初始化选中值
			console.log(this.selectParams);
			let separ = [];
			for(let i in this.selectParams){
				console.log(i,this.selectParams[i]);
				separ.push({param:i,paramVal:this.selectParams[i]});
			}
			this.$axios({
				url: this.HOST + '/admin.seo/keywordList',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					thispage: this.thispage,
					pagesize: this.pagesize,
					sort_param: this.sort_param,
					sort_type: this.sort_type,
					firstLoad: firstLoad,
					selectParams:separ
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						if (res.data.admin_err == 'admininfo_error') {
							this.$message.error(res.data.msg);
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.keywordList = res.data.data;
						this.total = res.data.total;
						if (firstLoad) {
							this.mlist = res.data.mlist;
							for(let i in this.mlist){
								this.filtrateList[0].seconds.push({
									val:this.mlist[i].mid,
									label:this.mlist[i].modelname
								})
							}
						}
					}
				})
				.catch(err => {});
		},
		selectChange(selection) {
			let arr = [];
			for (let i in selection) {
				arr.push(selection[i].kid);
			}
			this.selectedKeywordIds = arr;
			console.log(this.selectedKeywordIds);
		},
		addCommand(command) {
			console.log('add:', command);
		},
		setCommand(command) {
			console.log('set:', command);
			this.setParam = command.setParam;
			this.setParamVal = command.setParamVal;
			this.setKeywordParam();
		},
		setKeywordParam(){
			if(!this.selectedKeywordIds.length){
				this.$message.error('尚未选中任何内容');
				return false;
			}
			this.$axios({
				url: this.HOST + '/admin.seo/setKeywordParam',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					keywordIds:this.selectedKeywordIds,
					setParam:this.setParam,
					setParamVal:this.setParamVal
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						if (res.data.admin_err == 'admininfo_error') {
							this.$message.error(res.data.msg);
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.keywordList.map(item=>{
							if(this.selectedKeywordIds.indexOf(item.kid) !== -1){
								item[this.setParam] = this.setParamVal;
							}
						})
						this.$message.success(res.data.msg);
						// this.selectedKeywordIds = []//选中值初始化
					}
				})
				.catch(err => {});
		},
		seleCommand(command) {
			console.log('sele:', command);
			this.selectParams[command.param] = command.paramval;
			this.filtrateList[command.indexa].seconds.map(item => {
				this.$set(item, 'checked', false);
			});
			this.filtrateList[command.indexa].seconds[command.indexb].checked = true;
			console.log(this.selectParams);
			this.getKeywordList();
		},
		// 全选
		selectAll() {
			this.keywordList.map(item => {
				this.$refs.multipleTable.toggleRowSelection(item, true); //切换该子节点选中状态
			});
			// this.selectedKeywordIds = this.docIds;
		},
		// 反选
		selectDiff() {
			let diff = [];
			this.keywordList.map(item => {
				if (this.selectedKeywordIds.indexOf(item.kid) != -1) {
					this.$refs.multipleTable.toggleRowSelection(item, false); //切换该子节点选中状态
				} else {
					diff.push(item.kid);
					this.$refs.multipleTable.toggleRowSelection(item, true); //切换该子节点选中状态
				}
			});
			this.selectedKeywordIds = diff;
			console.log(this.selectedKeywordIds);
		},
		deleteKeyword() {
			if (!this.selectedKeywordIds.length) {
				this.$message.error('尚未选中任何优化词！');
				return false;
			}
			this.$confirm('是否要删除所选优化词？一经删除不可恢复！')
				.then(() => {
					this.$axios({
						url: this.HOST + '/admin.seo/deleteKeyword',
						method: 'post',
						data: {
							adminid: JSON.parse(this.$store.state.user.userInfo).id,
							token: JSON.parse(this.$store.state.user.userInfo).token,
							attrIds: this.selectedKeywordIds
						}
					})
						.then(res => {
							console.log(res.data);
							if (res.data.status == 0) {
								this.$message.error(res.data.msg);
								if (res.data.admin_err == 'admininfo_error') {
									this.exit().then(res => {
										console.log(res);
										if (res.actionStatus == 1) {
											this.$router.push('/login');
										}
									});
								}
							} else {
								this.$message.success(res.data.msg);
								this.getKeywordList();
							}
						})
						.catch(err => {});
				})
				.catch(() => {});
		},
		addKeyword(scope){
			if(scope){
				this.$router.push({path:'/keylink/addKeyword',query:{'kid':scope.kid}});
			}else{
				this.$router.push({path:'/keylink/addKeyword',query:{'kid':''}});
			}
		}
	}
};
</script>
<style lang="scss">
.el-main {
	padding: 0;
	.navpage {
		min-height: calc(100vh - 161px);
		.aside-primary {
			width: 240px;
			height: 100%;
			background-color: #ecf5ff;
			// height: 100%;
			padding: 20px;
			.el-divider__text {
				background-color: #ecf5ff;
				padding: 0 2px;
				font-size: 13px;
			}
			.el-menu-parent {
				background-color: transparent;
				.el-submenu {
					margin-bottom: 10px;
					background-color: #fff;
				}
				.el-menu-item {
					height: 45px;
					line-height: 45px;
					margin-bottom: 10px;
					background-color: #fff;
					min-width: 180px;
				}
			}
		}
		.width240 {
			width: 240px !important;
			transition: 0.8s;
		}
		.width0 {
			width: 0 !important;
		}
		.color-green {
			color: green;
		}
		.color-red {
			color: #ff2f4b;
		}
		.el-dropdown {
			margin: 0 10px;
		}
		.el-button + .el-button-group {
			margin-left: 10px;
			margin-right: 10px;
		}
		.el-button-group + .el-dropdown {
			margin-left: 0;
		}
	}
}
</style>
